import {
    Button,
    Card,
    ChoiceList,
    Select,
    Stack,
    TextStyle,
    DataTable,
    Heading,
} from "@shopify/polaris"
import React, { Component } from "react"
import axios from "../../funcs/axios"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Preloader from "../../components/Preloader"
import Actions from "../../actions"
import formatDateTime from "../../utils/formatDateTime"
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}
class ThemeIntegration extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: this.props.selected,
            selectReinstall: "1",
            appWaiting: false,
        }
    }

    handleReInstall() {
        const { selectReinstall, selected } = this.state
        const { actions } = this.props
        let data = {
            id: selected,
            option: selectReinstall[0],
        }
        this.setState({
            appWaiting: true,
            show: false,
        })
        axios
            .post(`${window.SHOPIFY_APP_HOST}/admin/install-wishlist-assets`, data)
            .then((response) => {
                const resObj = response.data
                if (resObj.status === "success") {
                    this.props.actions.AppNotify({
                        content: "Re-install successfully",
                        show: true,
                        error: false,
                    })
                    setTimeout(() => {
                        window.location.reload()
                    }, 0)
                } else {
                    throw new Error(resObj.msg)
                }
            })
            .catch((err) => {
                actions.AppNotify({
                    content: `Re-install fail. Please try again.`,
                    show: true,
                    error: true,
                })
            })
            .finally(() => {
                this.setState({
                    appWaiting: false,
                })
            })
    }
    render() {
        const { selected, selectReinstall, appWaiting } = this.state
        const { optionThemes, themesInstall } = this.props
        const rows = []
        optionThemes.map((item) => {
            let arr = []
            let released_date = "-"
            let version = "-"
            for (let i = 0; i < themesInstall.length; i++) {
                if (item.value === themesInstall[i].themeId) {
                    released_date = formatDateTime(themesInstall[i].released_date)
                    version = themesInstall[i].version
                    break
                }
            }
            arr.push(item.label, version, released_date)
            rows.push(arr)
        })
        return (
            <div>
                <div className="standard mt-50">
                    <div className="standard-left">
                        <Stack vertical className="standard-left">
                            <TextStyle variation="strong">Theme Integration</TextStyle>
                            <TextStyle variation="subdued">
                                As soon as you change the active theme, the Wishlist - Compare Plus
                                need to be integrated into a new one
                            </TextStyle>
                        </Stack>
                    </div>
                    <div className="standard-right">
                        <Stack vertical>
                            <Card>
                                <Card.Section>
                                    <Stack vertical>
                                        <Select
                                            label="Active Theme"
                                            options={optionThemes}
                                            onChange={(value) => {
                                                this.setState({
                                                    selected: +value,
                                                })
                                            }}
                                            value={selected}
                                        />
                                        <ChoiceList
                                            choices={[
                                                {
                                                    label: "Return default settings",
                                                    value: "0",
                                                },
                                                {
                                                    label: "Keep old settings adding new options only",
                                                    value: "1",
                                                },
                                            ]}
                                            selected={selectReinstall}
                                            onChange={(val) => {
                                                this.setState({
                                                    selectReinstall: val,
                                                })
                                            }}
                                        />
                                        <Button primary onClick={() => this.handleReInstall()}>
                                            Save
                                        </Button>
                                    </Stack>
                                </Card.Section>
                            </Card>
                        </Stack>
                    </div>
                    {appWaiting ? <Preloader /> : null}
                </div>
                <div className="mt-50">
                    <Heading>Themes</Heading>
                    <Card sectioned>
                        <DataTable
                            columnContentTypes={["text", "text", "text"]}
                            headings={["Label", "Version", "Released Date"]}
                            rows={rows}
                        />
                    </Card>
                </div>
            </div>
        )
    }
}

export default connect(null, mapDispatchToProps)(ThemeIntegration)
